// src/components/LedgerManagement/LedgerTabHeader.tsx
import React from "react";
import { motion } from "framer-motion";
import { useUser } from "src/business-types/grocery/components/UserContext";
import { colorOptions, fontOptions } from "src/shared/modules/profile/theme/themeConstants";

interface LedgerTabHeaderProps {
  activeTab: "Active" | "History";
  setActiveTab: (tab: "Active" | "History") => void;
}

const LedgerTabHeader: React.FC<LedgerTabHeaderProps> = ({ activeTab, setActiveTab }) => {
  const { user } = useUser();
  const bgClass = colorOptions[user?.background_colour || "DodgerBlue"] || "bg-blue-500";
  const fontClass = fontOptions[user?.font_family || "Sans-serif"];

  return (
    <div className={`ledger-tab-header ${fontClass} w-full mb-4`}>
      <div className="flex gap-1 p-1 bg-gray-100/80 backdrop-blur-sm rounded-2xl border border-gray-200/50 w-max">
        {/* Orders Tab */}
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => setActiveTab("Active")}
          className={`relative px-6 py-2 rounded-xl text-sm font-semibold transition-all duration-200 ${
            activeTab === "Active" ? "text-white" : "text-gray-600 hover:text-gray-900 hover:bg-white/50"
          }`}
        >
          {activeTab === "Active" && (
            <motion.div
              layoutId="activeLedgerTab"
              className={`absolute inset-0 rounded-xl ${bgClass} shadow-lg border-2 border-white/50`}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            />
          )}
          <span className="relative z-10">Orders</span>
        </motion.button>

        {/* History Tab */}
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => setActiveTab("History")}
          className={`relative px-6 py-2 rounded-xl text-sm font-semibold transition-all duration-200 ${
            activeTab === "History" ? "text-white" : "text-gray-600 hover:text-gray-900 hover:bg-white/50"
          }`}
        >
          {activeTab === "History" && (
            <motion.div
              layoutId="activeLedgerTab"
              className={`absolute inset-0 rounded-xl ${bgClass} shadow-lg border-2 border-white/50`}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            />
          )}
          <span className="relative z-10">History</span>
        </motion.button>
      </div>
    </div>
  );
};

export default LedgerTabHeader;
